import type { QueryKey } from "@tanstack/react-query";

/** Query-key factory for the staff earnings review board + pay-period ledger.
 *  Reads register under `earningsKeys.all`; every review/finalize mutation
 *  invalidates that prefix so the summary, grade, pay-period, and ledger reads
 *  refetch after an adjust/lock/unlock. */
export const earningsKeys = {
  all: ["leadgen-earnings"] as const,
  summary: (leadGeneratorId: string, weekOf: string): QueryKey => [
    ...earningsKeys.all,
    "summary",
    leadGeneratorId,
    weekOf,
  ],
  grade: (leadGeneratorId: string, weekOf: string): QueryKey => [
    ...earningsKeys.all,
    "grade",
    leadGeneratorId,
    weekOf,
  ],
  payPeriods: (leadGeneratorId: string): QueryKey => [
    ...earningsKeys.all,
    "pay-periods",
    leadGeneratorId,
  ],
  ledgerHistory: (leadGeneratorId: string): QueryKey => [
    ...earningsKeys.all,
    "ledger",
    "history",
    leadGeneratorId,
  ],
  ledgerWeek: (weekOf: string): QueryKey => [
    ...earningsKeys.all,
    "ledger",
    "week",
    weekOf,
  ],
  ledgerWeekLineItems: (leadGeneratorId: string, weekOf: string): QueryKey => [
    ...earningsKeys.all,
    "ledger",
    "week-line-items",
    leadGeneratorId,
    weekOf,
  ],
};
